import { Grid } from '@mui/material'
import { useMemo } from 'react'
import TabWrapper, { TabItem } from '../../../../components/TabWrapper/TabWrapper'
import UserGroupTable from '../../../CommonSettings/UserManagement/UserGroups/UserGroupTable'
import UserTable from '../../../CommonSettings/UserManagement/Users/UserTable'


const UserManagementTab = () => {
  const tabs: TabItem[] = useMemo(() => [
    {
      label: 'Users',
      content: (
        <Grid item xs={12}>
          <UserTable />
        </Grid>
      ),
    },
    {
      label: 'Users Groups',
      content: (
        <Grid item xs={12}>
          <UserGroupTable />
        </Grid>
      ),
    },
  ], [])

  return <TabWrapper tabs={tabs} variant='standard' />
}

export default UserManagementTab
